export enum DeviceType {
  MOBILE = "MOBILE",
  COMPUTER = "COMPUTER",
}
